import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { getImagePath } from '../../../utilities/product';
import { Helmet } from 'react-helmet';

const Source: any = styled.source`
  ${(props: any) => props.$style ?? {}}
`;

const Image: any = styled.img`
  ${(props: any) => props.$style ?? {}}
  ${(props: any) =>
    props.fullResolutionImage &&
    `
    max-height: 450px;
    width: auto;
  `}
`;

export interface Props {
  image?: string;
  alt?: string;
  width?: number;
  height?: number;
  width2x?: number;
  height2x?: number;
  noSize?: boolean;
  circle?: boolean;
  customStyles?: any;
  srcNoWebP?: string;
  srcWebP?: string;
  increment?: number;
  cover?: boolean;
  lazy?: boolean;
}

export class Picture extends React.Component<Props> {
  public render() {
    let { width, height } = this.props;
    const {
      image,
      alt,
      width2x,
      height2x,
      noSize,
      circle,
      customStyles,
      srcNoWebP,
      srcWebP,
      increment = 0,
      cover,
      lazy,
    } = this.props;

    const imageWidth = width;
    const imageHeight = height;
    if (increment) {
      if (width) {
        width = width + increment;
      }
      if (height) {
        height = height + increment;
      }
    }

    const dimensions = width && height ? { width, height } : undefined;
    const dimensions2x =
      width2x && height2x
        ? { width: width2x, height: height2x }
        : { width: (width || 0) * 2, height: (height || 0) * 2 };

    return (
      <>
        <picture>
          <Source
            type="image/webp"
            srcSet={
              srcWebP
                ? srcWebP
                : image
                ? dimensions && !noSize
                  ? `${getImagePath(
                      image,
                      dimensions,
                      noSize,
                      true,
                    )}, ${getImagePath(
                      image,
                      dimensions2x,
                      false,
                      true,
                      cover,
                    )} 2x`
                  : getImagePath(image, dimensions, noSize, true, cover)
                : '/images/icons/placeholder.svg'
            }
            // $style={customStyles}
          />
          <Source
            type="image/jpeg"
            srcSet={
              srcNoWebP
                ? srcNoWebP
                : image
                ? dimensions && !noSize
                  ? `${getImagePath(
                      image,
                      dimensions,
                      noSize,
                      false,
                      cover,
                    )}, ${getImagePath(
                      image,
                      dimensions2x,
                      false,
                      false,
                      cover,
                    )} 2x`
                  : getImagePath(image, dimensions, noSize, false, cover)
                : '/images/icons/placeholder.svg'
            }
            // $style={customStyles}
          />
          <Image
            loading={lazy ? 'lazy' : undefined}
            circle={circle}
            alt={alt}
            src={getImagePath(image, dimensions, noSize)}
            srcSet={
              srcNoWebP
                ? srcNoWebP
                : image
                ? dimensions && !noSize
                  ? `${getImagePath(
                      image,
                      dimensions,
                      noSize,
                      cover,
                    )}, ${getImagePath(image, dimensions2x, false, cover)} 2x`
                  : getImagePath(image, dimensions, noSize, cover)
                : '/images/icons/placeholder.svg'
            }
            $style={customStyles}
            height={
              noSize ? undefined : imageHeight === 0 ? undefined : imageHeight
            }
            width={
              noSize ? undefined : imageWidth === 0 ? undefined : imageWidth
            }
          />
        </picture>
      </>
    );
  }
}
